const LanguageIcon = ({ language = 'sv', size = 17, className = '' }: { language?: string; size?: number; className?: string }) => {
  return <span className={`language-icon language-${language} d-block rounded-circle ${className}`} style={{ width: `${size}px`, height: `${size}px` }} />;
};

export default LanguageIcon;
